import { Campaign, GetCampaignParams } from '@features/campaigns';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from '@features/users';
import { buildPresentation } from '@features/lci-report/subdomains/cpg/utils/build-presentation';
import { useCpgLciReportFields } from '@features/lci-report/subdomains/cpg/hooks/useCpgLciReportFields';
import { CpgReportsParams } from '@features/campaigns/subdomains/cpg/api/api';
import { clientDefaultValues } from '@features/lci-report/subdomains/cpg/utils/client-default-values';
import { presentationToFile } from '@features/powerpoint';
import { stringify } from 'qs';
import { LciReportDownloadButton } from './LciReportDownloadButton';
import { useFeatures } from '@utils/hooks';

type CpgLciReportDownloadButtonProps = {
  campaignId: Campaign['id'];
  reportParams: Omit<CpgReportsParams, 'campaignId'>;
  campaignParams: GetCampaignParams;
};

export const CpgLciReportDownloadContainer = (
  props: CpgLciReportDownloadButtonProps
) => {
  const navigate = useNavigate();
  const { role: userRole } = useCurrentUser();
  const features = useFeatures();

  const { data, loading } = useCpgLciReportFields({
    campaignParams: {
      ...props.campaignParams,
      id: props.campaignId,
    },
    reportParams: props.reportParams,
  });

  const onDownload = () => {
    if (!data) throw new Error('Missing data for presentation');

    const presentation = buildPresentation({
      data: { ...data, brandLogo: null },
      customFields: clientDefaultValues(data.report, data.campaign.name),
      features,
    });

    if (userRole === 'user') {
      void presentationToFile(presentation);
    } else {
      void navigate(
        `/campaigns/cpg/${props.campaignId}/lci-report?${stringify({ ...props.campaignParams, ...props.reportParams })}`
      );
    }
  };

  return (
    <LciReportDownloadButton
      loading={loading}
      userRole={userRole}
      onDownload={onDownload}
      disabled={loading}
    />
  );
};
